import { useEffect, useState } from "react";
import { UtensilsCrossed } from "lucide-react";
import { api } from "@/lib/api";

const BOX = { xs: "w-7 h-7 rounded-md", sm: "w-9 h-9 rounded-lg", md: "w-14 h-14 rounded-xl", lg: "w-24 h-24 rounded-2xl" };
const ICON = { xs: "w-3.5 h-3.5", sm: "w-4 h-4", md: "w-6 h-6", lg: "w-9 h-9" };
const cache = new Map();

// Fonte única: a imagem fica na ficha (recipe.image) e é baixada uma vez por versão, reaproveitada em todas as telas
const imageKey = (r) => (r?.image?.path ? `${r.id}:${r.image.updated_at || ""}` : null);
export const fetchProductImage = (r) => {
  const key = imageKey(r);
  if (!key) return Promise.resolve(null);
  if (!cache.has(key)) cache.set(key, api.get(`/recipes/${r.id}/image`, { params: { v: r.image.updated_at }, responseType: "blob" }).then((res) => URL.createObjectURL(res.data)).catch(() => null));
  return cache.get(key);
};

export const useProductImage = (r) => {
  const key = imageKey(r);
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let on = true;
    setUrl(null);
    if (key) fetchProductImage(r).then((u) => on && setUrl(u));
    return () => { on = false; };
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return url;
};

// Miniatura do produto com placeholder (ícone) quando não há imagem. `src` força uma prévia local (upload ainda não salvo).
export const ProductImage = ({ recipe, size = "md", className = "", testId, src }) => {
  const url = useProductImage(recipe);
  const shown = src || url;
  return (
    <div className={`${BOX[size]} shrink-0 overflow-hidden bg-secondary border border-border/60 flex items-center justify-center ${className}`} data-testid={testId || `product-image-${recipe?.id || "new"}`} data-has-image={shown ? "true" : "false"}>
      {shown ? <img src={shown} alt={recipe?.name || "Produto"} className="w-full h-full object-cover" loading="lazy" /> : <UtensilsCrossed className={`${ICON[size]} text-muted-foreground/60`} aria-label="Sem imagem" />}
    </div>
  );
};
